import React, { useRef, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import api, { errMsg } from "../../core/api";
import Logo from "../../components/Logo";
import PortScene from "../../components/PortScene";
import { AUTO_FOCUS, } from "../../core/device";
import "./Login.css";

export default function Login() {
  const navigate = useNavigate();
  const location = useLocation();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [show, setShow] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const busy = useRef(false);

  const submit = async (e) => {
    e.preventDefault();
    if (busy.current) return;
    if (!username.trim() || !password) return setError("نام کاربری و رمز عبور را وارد کنید");
    busy.current = true;
    setLoading(true);
    setError("");
    try {
      const { data } = await api.post("/auth/login", { username: username.trim(), password });
      localStorage.setItem("token", data.token);
      localStorage.setItem("user", JSON.stringify(data.user));
      navigate(location.state?.from?.pathname || "/", { replace: true });
    } catch (err) {
      setError(errMsg(err, "ورود ناموفق بود"));
    } finally {
      setLoading(false);
      busy.current = false;
    }
  };
return (
  <div className="login">
    {/* این بخش فقط در دسکتاپ نمایش داده می‌شود */}
    <section className="login-art">
      <PortScene className="scene" />
      <div className="login-photo" style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/port-bg.jpg)` }} />
      <div className="login-brand">
        <div className="login-logo-bg"><Logo size={84} /></div>
        <h1>سامانه ایمنی بندر تجاری و مسافری چارک</h1>
        <p>ایمنی، وظیفه ماست …</p>
        <div className="en">HSE Charak Port</div>
      </div>
    </section>

    <section className="login-side">
      <div className="login-card">
        <div className="logo-sm"><Logo size={56} /></div>
        <h2>ورود به سامانه</h2>
        <p className="sub">برای ورود، اطلاعات کاربری خود را وارد کنید</p>
        <form onSubmit={submit} noValidate>
          {error && <div className="alert err" role="alert">{error}</div>}
          <div className="field input-ico">
            <i className="fa-regular fa-user lead" />
            <input className="ltr" placeholder="نام کاربری" autoComplete="username" autoCapitalize="off" autoFocus={AUTO_FOCUS}
              value={username} onChange={(e) => setUsername(e.target.value)} aria-label="نام کاربری" />
          </div>
          <div className="field input-ico">
            <i className="fa-solid fa-lock lead" />
            <input className="ltr" placeholder="رمز عبور" type={show ? "text" : "password"} autoComplete="current-password"
              value={password} onChange={(e) => setPassword(e.target.value)} aria-label="رمز عبور" />
            <button type="button" className="eye" onClick={() => setShow((s) => !s)} aria-label="نمایش رمز">
              <i className={`fa-regular ${show ? "fa-eye-slash" : "fa-eye"}`} />
            </button>
          </div>
          <button className="btn btn-block" disabled={loading}>{loading ? "در حال ورود..." : "ورود"}</button>
        </form>
        <p className="foot">فراموشی رمز عبور؟ با ادمین سامانه تماس بگیرید.</p>
      </div>
    </section>
  </div>
);

}
